import { render, staticRenderFns } from "./surface_nav.vue?vue&type=template&id=2156c25a&scoped=true&"
import script from "./surface_nav.vue?vue&type=script&lang=js&"
export * from "./surface_nav.vue?vue&type=script&lang=js&"
import style0 from "./surface_nav.vue?vue&type=style&index=0&id=2156c25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156c25a",
  null
  
)

export default component.exports